import React from 'react';

import styled from 'styled-components';
import { mapTypeFilter, ChildTypeFilter } from 'utils/config';

import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  change,
  Field,
  FieldArray,
  formValueSelector,
  reduxForm,
} from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import RenderFieldCheckboxFilter from 'components/input/renderCheckboxFilter';
import * as _ from 'lodash';

import { ReactComponent as IconCloseFilter } from 'assets/img/icon/ic_close_filter.svg';
import { ReactComponent as IconReloadFilter } from 'assets/img/icon/ic_reload_filter.svg';
import RenderRangeFilter from 'components/input/renderRangeFilter';
import { makeGetAnalFilterRange } from 'lib/selector';
import { setToast } from 'containers/client/actions';
import { makeGetToken } from 'lib/selector';
import SaveFilterModal from './saveFilterModal';
import { analFilterActionRequest } from 'containers/market/actions';
import { makeGetAnalFilterAct } from 'lib/selector';
import { makeGetAnalUserFilter } from 'lib/selector';
import RenderFieldCriteriaLI from './layout/renderFieldCriteria';
import { log } from 'utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ImInfo } from 'react-icons/im';

//#region styled
const StyledHeader = styled.div`
  margin-top: 8px;
  width: 100%;
  display: grid;
  grid-template-columns: 277px 350px auto;
  gap: 8px;
`;

const StyledBody = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 281px 360px auto;
  gap: 0px;
`;

const StyledForm = styled.form`
  width: 100%;
  height: calc(100% - 40px);
`;

const StyledSubHeaderDef = styled.div`
  height: 32px;
  position: relative;
  background: #353342;
  color: #ececec;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  padding: 8px;

  &:before {
    content: '';
    position: absolute;
    z-index: 2;
    right: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 16px solid #353342;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
  }
`;

const StyledSubHeader = styled(StyledSubHeaderDef)`
  width: 275px;
  background-color: ${props => props.theme === 'dark' ? '#353342' : '#575757'};

  &:before {
    right: -16px;
    border-left: 16px solid ${props => props.theme === 'dark' ? '#353342' : '#575757'};
  }
`;

const StyledSubHeader2 = styled(StyledSubHeaderDef)`
  padding-left: 30px;
  display: flex;
  background-color: ${props => props.theme === 'dark' ? '#353342' : '#575757'};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 16px solid ${props => props.theme === 'dark' ? '#1c192c' : '#cacaca'};
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
  }

  &:before {
    z-index: 1;
    right: -16px;
    border-left: 16px solid ${props => props.theme === 'dark' ? '#353342' : '#575757'};
  }
`;

const StyledSubHeader3 = styled(StyledSubHeaderDef)`
  padding-left: 30px;
  padding-right: 20px;
  display: flex;
  background-color: ${props => props.theme === 'dark' ? '#353342' : '#575757'};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 16px solid ${props => props.theme === 'dark' ? '#1c192c' : '#cacaca'};
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
  }

  &:before {
    border: 0;
  }
`;

const StyledCondFilter = styled.div`
  background: ${props => props.theme === 'dark' ? '#1c192c' : '#C4C4C4'};
  border-radius: 0 0 0 4px;
  border: 1px solid #2e2d3d;
  border-width: 0 1px 1px 1px;
  padding: 8px;
  height: 100%;
  overflow: hidden;
`;

const StyledCondFilter2 = styled(StyledCondFilter)`
  border-radius: 0;
  border-width: 0 1px 1px 0px;
`;

const StyledCondFilter3 = styled(StyledCondFilter)`
  border-radius: 0 0 4px 0;
  border-width: 0 1px 1px 0px;
`;

const StyledUL = styled.ul`
  width: max-content;
  min-width: 100%;
`;

const StyledLI = styled.li`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${props => props.theme === 'dark' ? '#ececec' : '#000000'};
  padding: 8px 5px;
  border-radius: 4px;
  cursor: pointer;

  &.active {
    background: #f0b90b;
    color: #27272d;
  }
`;

const StyledLI2 = styled(StyledLI)`
  padding-top: 10px;
  border-bottom: 1px solid #2e2d3d;
`;

const StyledLI3 = styled(StyledLI)`
  padding-top: 6px;
  border-bottom: 1px solid #2e2d3d;
  
  a.d svg path{
    stroke: var(--red);
  }
`;

//#endregion

const validate = (values) => {
  const errors = {};
  // if (!values.clubName) {
  //   errors.clubName = 'Required';
  // }
  // if (!values.members || !values.members.length) {
  //   errors.members = { _error: 'Bạn phải thêm ít nhất 1 số serial' };
  // } else if (values.members.length > 10) {
  //   errors.members = { _error: 'Thêm tối đa 10 phần tử' };
  // } else {
  //   const membersArrayErrors = [];
  //   values.members.forEach((member, memberIndex) => {
  //     const memberErrors = {};
  //     if (!member || (!member.firstCode && !member.lastCode)) {
  //       memberErrors.firstCode = 'Hãy nhập giá trị';
  //       membersArrayErrors[memberIndex] = memberErrors;
  //     }
  //   });
  //   if (membersArrayErrors.length) {
  //     errors.members = membersArrayErrors;
  //   }
  // }
  return errors;
};

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function PanelConditionSearch(props) {
  const dispatch = useDispatch();
  const formRef = React.useRef();

  const [checkAll, setCheckAll] = React.useState(false);
  const [showAddFilter, setShowAddFilter] = React.useState(false);

  const {
    headerFilter,
    token,
    condFilter,
    criteria,
    criteriaMember,
    criteriaValue,
    analFilterRange,
    analFilterAct,
    analUserFilter,
    svFilter,
    setSaveFilter,
    setCondSearch,
    t,
    theme,
    clearFiler,
    setClearFilter
  } = props;

  const preHeaderFilter = usePrevious(headerFilter?.filter);
  const preCriteriaValue = usePrevious(criteriaValue);

  React.useEffect(() => {
    if (condFilter) {
      changeCriteria();
    }
  }, [condFilter]);

  React.useEffect(() => {
    if (svFilter) {
      setSaveFilter(false);
      setShowAddFilter(true);
    }
  }, [svFilter]);

  React.useEffect(() => {
    if (clearFiler) {
      setClearFilter(false);
      setCheckAll(false);

      dispatch(change('formConditionSearch', 'criteriaMember', []));
      dispatch(change('formConditionSearch', 'criteriaValue', []));
      dispatch(change('formConditionSearch', 'condFilter', 'THONG_TIN_CHUNG'));
    }
  }, [clearFiler]);

  React.useEffect(() => {
    if (!_.isEqual(criteriaValue, preCriteriaValue)) {
      let newArr = _.map(criteriaValue, o => _.pick(o, ['itemName', 'itemValue']));
      // log(criteriaValue)
      setCondSearch(newArr)
    }
  }, [criteriaValue]);

  React.useEffect(() => {
    if (
      headerFilter &&
      headerFilter?.filter &&
      !_.isEqual(headerFilter?.filter, preHeaderFilter)
    ) {
      const _saveFilter = _.find(
        analUserFilter,
        (o) => o.FilterId == headerFilter?.filter
      );

      if (_saveFilter) {
        // clear dk search
        dispatch(change('formConditionSearch', 'criteriaMember', []));
        dispatch(change('formConditionSearch', 'criteriaValue', []));

        processSaveFilter(_saveFilter);
      }
    }
  }, [headerFilter]);

  function processSaveFilter(params) {
    // log('processSaveFilter', params)
    setCheckAll(false);
    const _arrSaveFilter = JSON.parse(params.Criteria);
    let criteria = [];

    // const keysCrit = Object.keys(mapTypeFilter);

    const _keys = _.union(
      _.map(
        _.filter(ChildTypeFilter, (o) =>
          _.some(_arrSaveFilter, (p) => p.code === o.type)
        ),
        'group'
      )
    );

    // log('processSaveFilter', _keys);

    if(_keys && !!_keys.length) dispatch(change('formConditionSearch', 'condFilter', _keys[0]));

    Object.keys(mapTypeFilter).forEach((element) => {
      criteria.push({
        itemCheck: _.some(_keys, (o) => o === element),
        itemName: t('algo.bl.type.' + element), // mapTypeFilter[element],
        itemValue: element,
      });
    });

    dispatch(change('formConditionSearch', 'criteria', criteria));

    let criteriaMembers = [], criteriaValues = [];

    _keys.forEach((element) => {
      const _filter = _.filter(ChildTypeFilter, (o) => o.group === element);
      _filter.forEach((element) => {
        const _filterRange = _.find(
          analFilterRange,
          (o) => o.code === element.type
        );
        const _filterSave = _.find(
          _arrSaveFilter,
          (o) => o.code === element.type
        );
        // log(_filterRange);
        criteriaMembers.push({
          itemCheck: _filterSave ? true : false,
          itemName: t('algo.bl.' + element.group + '.' + element.type),
          itemValue: element.type,
          itemRange: _filterSave
            ? [_filterSave?.low, _filterSave?.high]
            : [_filterRange?.low ?? 0, _filterRange?.high ?? 0],
          itemMinMax: [_filterRange?.low || 0, _filterRange?.high || 0],
        });

        if(_filterSave){
          criteriaValues.push({
            itemName: t('algo.bl.' + element.group + '.' + element.type),
            itemValue: element.type,
            itemRange: [_filterSave?.low, _filterSave?.high],
            itemMinMax: [_filterRange?.low || 0, _filterRange?.high || 0],
          });
        }
      });
    });

    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMembers));
    dispatch(change('formConditionSearch', 'criteriaValue', criteriaValues));
  }

  function changeCriteria() {
    let criteria = [];
    Object.keys(mapTypeFilter).forEach((element) => {
      criteria.push({
        itemCheck: false,
        itemName: t('algo.bl.type.' + element), //mapTypeFilter[element],
        itemValue: element,
      });
    });

    dispatch(change('formConditionSearch', 'criteria', criteria));
  }

  function _handleChangeCriteriaMember(e) {
    const { checked } = e.target;
    const itemid = e.target.getAttribute('itemid');

    let criteriaMembers = [...criteriaMember];
    const _filter = _.filter(ChildTypeFilter, (o) => o.group === itemid);
    // log(_filter, checked);

    if (checked) {
      _filter.forEach((element) => {
        const _filterRange = _.find(
          analFilterRange,
          (o) => o.code === element.type
        );
        // log(_filterRange);
        criteriaMembers.push({
          itemCheck: checkAll,
          itemName: t('algo.bl.' + element.group + '.' + element.type),
          itemValue: element.type,
        });
      });
    } else {
      const _rm = _.remove(criteriaMembers, (o) =>
        _.some(_filter, (p) => p.type === o.itemValue)
      );
    }

    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMembers));
  }

  function _handleChangeCriteriaValue(e) {
    const { checked, itemID } = e;
    // const itemid = e.target.getAttribute('itemid');

    criteriaMember.map(item => {
      if(item.itemValue === itemID)
        item.itemCheck = checked;
      
        return item;
    })

    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMember));

    let criteriaValues = _.isArray(criteriaValue) ? [...criteriaValue] : [];

    // log(criteriaValue)

    if (checked) {
      const _filterRange = _.find(analFilterRange, (o) => o.code === itemID);
      const _criteriaMember = _.find(criteriaMember, (o) => o.itemValue === itemID);
      // log(_filterRange);
      criteriaValues.push({
        itemName: _criteriaMember.itemName,
        itemValue: _criteriaMember.itemValue,
        itemRange: [_filterRange?.low ?? 0, _filterRange?.high ?? 0],
        itemMinMax: [_filterRange?.low || 0, _filterRange?.high || 0],
      });
    } else {
      const _rm = _.remove(criteriaValues, (o) => o.itemValue === itemID);
    }

    dispatch(change('formConditionSearch', 'criteriaValue', criteriaValues));
  }

  function _handleRemoveValue(value) {
    let criteriaMembers = [...criteriaMember];
    criteriaMembers.map(item => {
      if(item.itemValue === value) item.itemCheck = false;

      return item;
    })

    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMembers));
  }

  //#region render field
  const renderCriteria = ({ fields, meta: { error, submitFailed } }) => (
    <StyledUL>
      {fields.map((item, index) => {
        return (
          <StyledLI key={index} className="d-flex" theme={theme}>
            <Field
              name={`${item}.itemCheck`}
              itemID={fields.get(index).itemValue}
              component={RenderFieldCheckboxFilter}
              labelName={fields.get(index).itemName}
              onChange={_handleChangeCriteriaMember}
            />
          </StyledLI>
        );
      })}
    </StyledUL>
  );

  const renderCriteriaMember = ({ fields, meta: { error, submitFailed } }) => (
    <StyledUL>
      {fields.map((item, index) => {
        return (
          <StyledLI2 key={index} className="d-flex" theme={theme}>
            <Field
              name={`${item}.itemCheck`}
              itemID={fields.get(index).itemValue}
              component={RenderFieldCriteriaLI}
              labelName={fields.get(index).itemName}
              // className={'range-check'}
              handleChange={_handleChangeCriteriaValue}
              t={t}
            />
            {/* <div className="ml-auto d-flex align-items-center">
              <Field
                name={`${item}.itemRange`}
                itemID={fields.get(index).itemValue}
                minMax={fields.get(index).itemMinMax}
                component={RenderRangeFilter}
              />
              <a className="ml-5" onClick={() => fields.remove(index)}>
                <IconCloseFilter />
              </a>
            </div> */}
          </StyledLI2>
        );
      })}
    </StyledUL>
  );

  const renderCriteriaValue = ({ fields, meta: { error, submitFailed } }) => (
    <StyledUL>
      {fields.map((item, index) => {
        console.log(fields.get(index))

        const _field = fields.get(index);

        return (
          <StyledLI3 key={index} className={"d-flex align-items-center theme-" + theme} theme={theme}>
            <a className="d mr-2" onClick={() => {
              _handleRemoveValue(_field.itemValue)
              fields.remove(index);
            }}>
              <IconCloseFilter />
            </a>
            <span className="mr-auto text-nowrap pr-2">{_field.itemName}
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id={`tooltip-right`}>
                  {t('algo.tooltip.' + _field.itemValue)}
                </Tooltip>
              }
            >
              <ImInfo className="ml-2 fz-12 txt-content" />
            </OverlayTrigger>
            </span>
            <Field
              name={`${item}.itemRange`}
              // itemID={_field.itemValue}
              minMax={_field.itemMinMax}
              component={RenderRangeFilter}
            />
          </StyledLI3>
        );
      })}
    </StyledUL>
  );

  //#endregion

  function _handleClickFilterType(type) {
    dispatch(change('formConditionSearch', 'condFilter', type));
    const _filter = _.filter(ChildTypeFilter, (o) => o.group === type);

    let criteriaMembers = [];
    
    // log(_filter);

    _filter.forEach((element) => {
      // const _filterRange = _.find(
      //   analFilterRange,
      //   (o) => o.code === element.type
      // );

      // log(_filterRange);
      
      criteriaMembers.push({
        itemCheck: _.some(criteriaValue, o => o.itemValue === element.type),
        itemName: t('algo.bl.' + element.group + '.' + element.type),
        itemValue: element.type,
      });
    });

    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMembers));
  }

  function handleChangeCheckAll(e) {
    const { checked } = e.target;
    // log(checked);
    setCheckAll(checked);

    let criteriaMembers = [...criteriaMember],
    criteriaValues = [];

    criteriaMembers.forEach((element) => {
      element.itemCheck = checked;
      if(checked){
        const _filterRange = _.find(analFilterRange, (o) => o.code === element.itemValue);
        criteriaValues.push({
          itemName: element.itemName,
          itemValue: element.itemValue,
          itemRange: [_filterRange?.low ?? 0, _filterRange?.high ?? 0],
          itemMinMax: [_filterRange?.low || 0, _filterRange?.high || 0],
        });
      }
    });
    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMembers));
    dispatch(change('formConditionSearch', 'criteriaValue', criteriaValues));
  }


  function _handleDellAll() {
    setCheckAll(false);
    let criteriaMembers = [...criteriaMember];
    criteriaMembers.forEach((element) => {
      element.itemCheck = false;
    });
    dispatch(change('formConditionSearch', 'criteriaMember', criteriaMembers));
    dispatch(change('formConditionSearch', 'criteriaValue', []));
  }

  function submitForm(values) {
    // log(values, headerFilter);

    if (analFilterAct || headerFilter?.name) {
      // tải lại kết quả
      saveFilter(headerFilter?.name, true, 'R');
    } else {
      // chưa search
      if (!headerFilter?.filter || headerFilter?.filter === 'APEC') {
        setShowAddFilter(true);
      } else {
        saveFilter(headerFilter?.name, true, 'RU');
      }
    }

    // const _memberCheck = _.filter(criteriaMember, o => o.itemCheck)
    // log(_memberCheck)
  }

  function saveFilter(name, isDef, action = 'RC') {
    // const _memberCheck = _.filter(criteriaMember, (o) => o.itemCheck);
    // log(_memberCheck, name, isDef, token);
    if (!token) return;

    // headerFilter
    let _params = {};
    _params.lang = 'vi';
    _params.action = action;
    // RC: chạy và tạo mới bộ lọc
    // R: chạy bộ lọc
    // RU: chạy và cập nhật bộ lọc
    _params.name = action === 'R' ? 'false' : name; // Với action = ‘R’ thì name = ‘false'
    _params.filterId =
      action === 'RC' ? '' : analFilterAct?.filterId || headerFilter?.filter;
    _params.user = token?.user;
    _params.exchange = headerFilter?.index || 'HOSE,HSX,UPCOM'; // HOSE, HNX, UPCOM
    _params.industry = headerFilter?.industry;

    const _filter = [];

    criteriaValue.forEach((element) => {
      _filter.push({
        code: element.itemValue,
        low: element.itemRange[0],
        high: element.itemRange[1],
      });
    });

    _params.filter = _filter;

    dispatch(analFilterActionRequest(_params));
    setShowAddFilter(false);
  }

  function handleClickReload() {
    if (criteriaValue && !!criteriaValue.length) {
      formRef.current && formRef.current.dispatchEvent(new Event('submit'));
    } else {
      handleToast('Quý khách chưa chọn giá trị!', 'warning');
    }
  }

  function handleToast(msg, type = 'info') {
    // log(msg)
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
      type,
    };
    dispatch(setToast(toastMsg));
  }

  const { handleSubmit, submitting, pristine, reset } = props;

  // log(headerFilter);

  return (
    <div
      className="w-100 h-100 f-flex flex-column"
      style={{ padding: '8px', borderRadius: '4px' }}
    >
      <StyledHeader>
        <StyledSubHeader theme={theme}>{t('algo.lcp.txt-Select-filter-condition')}</StyledSubHeader>
        <StyledSubHeader2 theme={theme}>
          <span>{t('algo.lcp.txt-Select-criteria')}</span>
        </StyledSubHeader2>
        <StyledSubHeader3 theme={theme}>
          <span>{t('algo.lcp.txt-Input-value')}</span>

          <div className="ml-auto d-flex">
            <a
              onClick={handleClickReload}
              className="d-flex align-items-center"
            >
              {t('algo.lcp.txt-Reload-result')} {' '}
              <IconReloadFilter
                style={{ width: '15px', height: '15px', marginLeft: '6px' }}
              />
            </a>
            <a
              onClick={_handleDellAll}
              className="d-flex align-items-center"
              style={{ marginLeft: '40px' }}
            >
              {t('algo.lcp.txt-Clear-all')} {' '}
              <IconCloseFilter
                style={{ width: '12px', height: '12px', marginLeft: '6px' }}
              />
            </a>
          </div>
        </StyledSubHeader3>
      </StyledHeader>
      <StyledForm ref={formRef} onSubmit={handleSubmit(submitForm)}>
        <StyledBody>
          <StyledCondFilter theme={theme}>
            <PerfectScrollbar>
              <StyledUL>
                {
                  criteria && criteria.map((item, index) => (
                    <StyledLI
                      key={index}
                      onClick={() => _handleClickFilterType(item.itemValue)}
                      className={condFilter === item.itemValue ? 'active' : ''}
                      theme={theme}
                    >
                      {item.itemName}
                    </StyledLI>
                  ))
                }
              </StyledUL>
            </PerfectScrollbar>
          </StyledCondFilter>

          <StyledCondFilter2 theme={theme}>
            <PerfectScrollbar>
              <FieldArray
                name="criteriaMember"
                component={renderCriteriaMember}
              />
            </PerfectScrollbar>
          </StyledCondFilter2>

          <StyledCondFilter3 theme={theme}>
            <PerfectScrollbar>
              <FieldArray
                name="criteriaValue"
                component={renderCriteriaValue}
              />
            </PerfectScrollbar>
          </StyledCondFilter3>
        </StyledBody>
      </StyledForm>
      {showAddFilter && (
        <SaveFilterModal
          onClose={() => setShowAddFilter(false)}
          saveFilter={saveFilter}
          hasNew={!headerFilter?.name}
          headerFilter={headerFilter}
          theme={theme}
        />
      )}
    </div>
  );
}

PanelConditionSearch = reduxForm({
  form: 'formConditionSearch',
  enableReinitialize: true,
  validate,
})(PanelConditionSearch);

const selector = formValueSelector('formConditionSearch');

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAnalFilterRange = makeGetAnalFilterRange();
  const getAnalFilterAct = makeGetAnalFilterAct();
  const getAnalUserFilter = makeGetAnalUserFilter();

  const mapStateToProps = (state) => {
    const { condFilter, criteria, criteriaMember, criteriaValue } = selector(
      state,
      'condFilter',
      'criteria',
      'criteriaMember',
      'criteriaValue'
    );

    return {
      token: getToken(state),
      analFilterRange: getAnalFilterRange(state),
      analFilterAct: getAnalFilterAct(state),
      analUserFilter: getAnalUserFilter(state),

      condFilter,
      criteria,
      criteriaMember,
      criteriaValue,
      initialValues: {
        condFilter: 'THONG_TIN_CHUNG',
        criteria: [],
        criteriaMember: [],
        criteriaValue: [],
      },
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(PanelConditionSearch);
